import React from 'react'

import Dropdown from '@ublique/components/Dropdown'
import TextInput from '@ublique/components/TextInput'
import MultiSelect from '@ublique/components/MultiSelect'

import '../index.scss'

const FormField = React.memo(
  ({
    t,
    id,
    name,
    labelText,
    label,
    placeholder,
    value,
    handleChange,
    isDisabled,
    isInvalid,
    invalidText,
    type,
    itemsList,
    permissionType,
    selectedItem,
    initialSelectedItems,
    customLabelText
  }) => {
    if (type === 'text') {
      return (
        <div className='text-input'>
          {customLabelText && (
            <div className='custom-label-text'>
              <span>{t(customLabelText)}</span>
            </div>
          )}
          <TextInput
            id={`${id}-${Math.random()}`}
            onChange={handleChange}
            labelText={t(label)}
            value={value}
            invalidText={t(invalidText)}
            invalid={!!isInvalid}
            disabled={!!isDisabled}
            light
            type={type}
            autocomplete='new-password'
            required
          />
        </div>
      )
    }
    if (type === 'multiselect') {
      return (
        <div className='multiselect-input'>
          <MultiSelect
            id={`${id}-${Math.random()}`}
            ariaLabel='MultiSelect'
            useTitleInItem={false}
            initialSelectedItems={itemsList}
            titleText={t(label)}
            label={t(label)}
            light
            invalidText={t(invalidText)}
            invalid={!!isInvalid}
            disabled={!!isDisabled}
            name={name || id}
            value={value}
            onChange={handleChange}
            items={itemsList}
            itemToString={(item) => (item ? t(item.label) : '')}
          />
        </div>
      )
    }
    if (type === 'select') {
      return (
        <div className='multiselect-input'>
          <Dropdown
            id={`${id}-${Math.random()}`}
            ariaLabel='Dropdown'
            useTitleInItem={false}
            titleText={t(labelText)}
            label={t(labelText)}
            placeholder={t(placeholder)}
            light
            selectedItem={selectedItem?.value ? selectedItem : null}
            invalidText={t(invalidText)}
            invalid={!!isInvalid}
            disabled={!!isDisabled}
            onChange={handleChange}
            name={name || id}
            items={itemsList}
            itemToString={(item) => (item ? t(item.label) : '')}
          />
        </div>
      )
    }
    return null
  }
)

const DefaultForm = ({ key, formFields, t, permissionType }) => {
  return (
    <div key={key} className='default-form'>
      {formFields.map((field) => {
        return (
          <FormField
            {...field}
            t={t}
            key={field.id}
            permissionType={permissionType}
          />
        )
      })}
    </div>
  )
}

export default DefaultForm
